import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
import styled from "styled-components";

import { useFaireDirectFirstOrderIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";

export const FaireDirectHeaderBanner: React.FC = () => {
  const {
    isFaireDirectCreditPercentageBased,
    formattedPercentageBasedNumber,
    formattedFixedBasedAmount,
  } = useFaireDirectFirstOrderIncentive();

  return (
    <BannerWrapper>
      <Typography align="center">
        {isFaireDirectCreditPercentageBased ? (
          <StrictLocalMsg
            defaultMessage="Order through Faire and get {faireDirectPercentageDiscountNumber} off your first order and 1 year of free shipping."
            description={{
              text: "Telling a prospective retailer the benefits of signing up to Faire to order from a Brand",
              img: "https://cdn.faire.com/fastly/0b92bf0a718acf127da6eef5991e17b773376e1f320802b2bca3d97136e53e36.png",
            }}
            values={{
              faireDirectPercentageDiscountNumber:
                formattedPercentageBasedNumber,
            }}
          />
        ) : (
          <StrictLocalMsg
            defaultMessage="Order through Faire and get {discountMoney} off your first order and 1 year of free shipping."
            description={{
              text: "Telling a prospective retailer the benefits of signing up to Faire to order from a Brand",
              img: "https://cdn.faire.com/fastly/765a5039ef9886d059fae376988827e0da158dcba6c24493a2de06a1a772cde9.png",
            }}
            values={{
              discountMoney: formattedFixedBasedAmount,
            }}
          />
        )}
      </Typography>
    </BannerWrapper>
  );
};

const BannerWrapper = styled(Column).attrs({ align: "center" })`
  width: 100%;
  padding: 12px;
  background-color: ${Decorative.tint.neutral};
`;
